import {z} from 'zod';

import {BaseVoidRequestSchema, BaseVoidResponseSchema} from '@dms/api/shared';

export const ServiceItemMoveReasonSchema = z.object({
  id: z.string(),
  name: z.string(),
  isDefault: z.boolean(),
  isActive: z.boolean(),
});

export type ServiceItemMoveReason = z.infer<typeof ServiceItemMoveReasonSchema>;

export const GetServiceItemMoveReasonsApiResponseSchema = z.array(ServiceItemMoveReasonSchema);

export type GetServiceItemMoveReasonsApiResponse = z.infer<
  typeof GetServiceItemMoveReasonsApiResponseSchema
>;

export const GetServiceItemMoveReasonsApiArgSchema = BaseVoidRequestSchema;

export type GetServiceItemMoveReasonsApiArg = z.infer<typeof GetServiceItemMoveReasonsApiArgSchema>;

export const PostServiceItemMoveReasonApiResponseSchema = ServiceItemMoveReasonSchema;

export type PostServiceItemMoveReasonApiResponse = z.infer<
  typeof PostServiceItemMoveReasonApiResponseSchema
>;

export const PostServiceItemMoveReasonApiArgSchema = z.object({
  body: z.object({
    name: z.string(),
  }),
});

export type PostServiceItemMoveReasonApiArg = z.infer<typeof PostServiceItemMoveReasonApiArgSchema>;

export const GetServiceItemMoveReasonApiResponseSchema = ServiceItemMoveReasonSchema;

export type GetServiceItemMoveReasonApiResponse = z.infer<
  typeof GetServiceItemMoveReasonApiResponseSchema
>;

export const GetServiceItemMoveReasonApiArgSchema = z.object({
  codelistId: z.string(),
});

export type GetServiceItemMoveReasonApiArg = z.infer<typeof GetServiceItemMoveReasonApiArgSchema>;

export const PatchServiceItemMoveReasonApiResponseSchema = BaseVoidResponseSchema;

export type PatchServiceItemMoveReasonApiResponse = z.infer<
  typeof PatchServiceItemMoveReasonApiResponseSchema
>;

export const PatchServiceItemMoveReasonApiArgSchema = z.object({
  codelistId: z.string(),
  body: z.object({
    name: z.string(),
  }),
});

export type PatchServiceItemMoveReasonApiArg = z.infer<
  typeof PatchServiceItemMoveReasonApiArgSchema
>;

export const PatchServiceItemMoveReasonSetActiveApiResponseSchema = BaseVoidResponseSchema;

export type PatchServiceItemMoveReasonSetActiveApiResponse = z.infer<
  typeof PatchServiceItemMoveReasonSetActiveApiResponseSchema
>;

export const PatchServiceItemMoveReasonSetActiveApiArgSchema = z.object({
  codelistId: z.string(),
});

export type PatchServiceItemMoveReasonSetActiveApiArg = z.infer<
  typeof PatchServiceItemMoveReasonSetActiveApiArgSchema
>;

export const PatchServiceItemMoveReasonSetInactiveApiResponseSchema = BaseVoidResponseSchema;

export type PatchServiceItemMoveReasonSetInactiveApiResponse = z.infer<
  typeof PatchServiceItemMoveReasonSetInactiveApiResponseSchema
>;

export const PatchServiceItemMoveReasonSetInactiveApiArgSchema = z.object({
  codelistId: z.string(),
});

export type PatchServiceItemMoveReasonSetInactiveApiArg = z.infer<
  typeof PatchServiceItemMoveReasonSetInactiveApiArgSchema
>;

export const PatchServiceItemMoveReasonSetDefaultApiResponseSchema = BaseVoidResponseSchema;

export type PatchServiceItemMoveReasonSetDefaultApiResponse = z.infer<
  typeof PatchServiceItemMoveReasonSetDefaultApiResponseSchema
>;

export const PatchServiceItemMoveReasonSetDefaultApiArgSchema = z.object({
  codelistId: z.string(),
});

export type PatchServiceItemMoveReasonSetDefaultApiArg = z.infer<
  typeof PatchServiceItemMoveReasonSetDefaultApiArgSchema
>;

export const PatchServiceItemMoveReasonUnsetDefaultApiResponseSchema = BaseVoidResponseSchema;

export type PatchServiceItemMoveReasonUnsetDefaultApiResponse = z.infer<
  typeof PatchServiceItemMoveReasonUnsetDefaultApiResponseSchema
>;

export const PatchServiceItemMoveReasonUnsetDefaultApiArgSchema = z.object({
  codelistId: z.string(),
});

export type PatchServiceItemMoveReasonUnsetDefaultApiArg = z.infer<
  typeof PatchServiceItemMoveReasonUnsetDefaultApiArgSchema
>;
